<nav
  class="footer bg-main py-1 text-white absolute bottom-0 left-0 w-full flex align-items-center justify-content-center"
>
  <p class="inline-block p-1">
    Licensed by
    <a
      target="_blank"
      class="font-bold text-white"
      href="https://softech-solutions.com/"
      >Softech Solutions</a
    >
    ©{{ year }}
  </p>
</nav>
